import { render, staticRenderFns } from "./docpage.vue?vue&type=template&id=e3778852&scoped=true&"
import script from "./docpage.vue?vue&type=script&lang=js&"
export * from "./docpage.vue?vue&type=script&lang=js&"
import style0 from "./docpage.vue?vue&type=style&index=0&id=e3778852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3778852",
  null
  
)

export default component.exports